import Slider, { SliderProps } from "rc-slider";
import "rc-slider/assets/index.css";

const Range = (props: SliderProps) => {
  return (
    <Slider
      styles={{
        rail: { backgroundColor: "#EEEEEE" },
        track: { backgroundColor: "#000000" },
        handle: {
          backgroundColor: "#000000",
          border: "none",
          outline: "none",
          opacity: 1,
          boxShadow: "none",
        },
      }}
      {...props}
    />
  );
};

export default Range;
